export interface InsightPayload {
  class: string;
  entityId: string;
  tripId: string | null;
}

export interface DrivingCondition {
  attributeName: string;
  actualValue: string;
  prescribedValue: string;
  currentImage?: string;
}

export interface OptimizationTip {
  attributeName: string;
  text: string;
  outcome: string;
}

export interface TripInfo {
  tripId: string;
  vehicleId: string;
  startLocation: string;
  endLocation: string;
  startTime: string;
  endTime: string;
  distance: string | number;
  duration: number;
  avgSpeed: string | number;
  maxSpeed: string | number;
  remainingRange: number;
  tags?: any;
  imageUrl?: string;
}

export interface EVRangeData {
  tripInfo: TripInfo;
  maximumRange: number;
  optimizationTips: OptimizationTip[];
  drivingConditions: DrivingCondition[];
}

export interface ApiInsightResponse {
  class: string;
  type: string;
  tenantId: string;
  entityId: string;
  tripId: string;
  model: string;
  version: string;
  dataFrom: string;
  dataTo: string;
  modelStart: string;
  modelStop: string;
  modelOutput: {
    summary ?: {
      note: string;
      score: number
    };
    drivingConditions: Array<{
      attributeName: string;
      actualValue: string;
      prescribedValue: string;
    }>;
    calculations: {
      possibleRange: string;
      maxRange: string;
      rangeImprovement: string;
    };
    optimizationTips: Array<{
      attributeName: string;
      text: string;
      outcome: string;
    }>;
  };
}

export interface ModelOutput {
  summary ?: {
    note: string;
    score: number
  };
  drivingConditions: Array<{
    attributeName: string;
    actualValue: string;
    prescribedValue: string;
  }>;
  calculations: {
    possibleRange: string;
    maxRange: string;
    rangeImprovement: string;
  };
  optimizationTips: Array<{
    attributeName: string;
    text: string;
    outcome: string;
  }>;
}

export interface TripItem {
  id?: string;
  tripLabel ?: string;
  icon?: string;
  class: string;
  type: string;
  tenantId: string;
  entityId: string;
  tripId: string;
  model: string;
  version: string;
  dataFrom: string;
  dataTo: string;
  modelStart: string;
  modelStop: string;
  modelOutput: any;
  receivedTimestamp: string;
  currentLocation?: [number, number];
}

export interface SummaryDetails {
  tripName: string;
  entityName: string;
  tripStartDate: string;     
  startLocation: string;
  tripEndDate: string;       
  startTime: string;         
  endTime: string;           
  endLocation: string;
  distanceTravelled: number; 
  timeTaken: number;         
  avgSpeed: number;          
  topSpeed: number;          
  remainingRange: number | null;
  tags: string[];   
  imageUrl ?: string;
  entityId ?: string;         
}

export interface TripSummaryDetails {
  timeTakenInMin: number;
  distanceTravelled: number;
  from: {
    time: string; 
    coordinates: {
      lat: number;
      long: number;
    };
  };
  to: {
    time: string; 
    coordinates: {
      lat: number;
      long: number;
    };
  };
  topSpeed: number;
  avgSpeed: number;
}

export type TripDate = Date | { tripId: string; start: any; end: any, tripName ?: string };

export interface AttributeValues {
  windowAvg: string;
  attributeValue: string;
  attributeName: string;
  RateDiff: string;
  operation: string;
  RawValue: number[]; 
}